import React, { useEffect } from 'react';
import { licitacionesPublicas } from '../../json/licitacionesPublicas2022';
import '../LicitacionesPublicas/licitacionesPublicas.css';


  const DetalleLicitacion2022 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
        <div className="row">
              <div> 
                  <h3 className="title">Licitaciones Públicas 2022</h3>
                  <hr className="hr-gob" />
              </div>

         <div style={{ width: "100%" }}>
            <table className="table table-striped table-bordered">
                      <tr>
                        <th scope="col" colspan="2"><div className="detalle_nombreLicitacion" style={{ width: "460px" }}>Licitación Pública No.</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Convocatoria</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Bases</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Junta de aclaraciones</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Presentación y Apertura</div></th>
                        <th scope="col"><div style={{ width: "150px" }}>Fallo</div></th>
                      </tr>
            </table>
         </div>
            
            <div className="contenedor-tabla">
            <table className="table table-striped table-bordered tabla-elementos">
                    <tbody>
                       {
                        licitacionesPublicas.map((item, index)=>(
                          <tr key={ index }>
                              <th><div className="detalle_i"><i className="bi bi-file-earmark-pdf-fill"></i></div></th>
                              <th scope="row">
                                <div className="detalle_Licitacion"> { item.Nombre } </div>
                              </th>
                              <td>
                                <div className="div-elementos">
                                    <a href={ item.linkConvocatoria } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'>PDF</button></a> 
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                    <a href={ item.linkBases } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'>PDF</button></a>  
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                    <a href={ item.linkActaAclaraciones } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'>PDF</button></a> 
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                    <a href={ item.linkActaApertura } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'>PDF</button></a> 
                                </div>
                              </td>
                              <td>
                                <div className="div-elementos">
                                    <a href={ item.linkActaFallo } target="_blank" rel="noopener noreferrer"><button className='btn btn-default btn-pdf' type='button'>PDF</button></a> 
                                </div>
                              </td>
                          </tr>
                        ))
                       }  
                  </tbody>
              </table>
          </div>         
       </div>
    </div>
    )
}

export default DetalleLicitacion2022